// extracted by mini-css-extract-plugin
export default {"bagBtn":"singleProductPage_bagBtn__0KzyG","giftBtn":"singleProductPage_giftBtn__d0Hxe"};